import React, { useEffect, useMemo, useState, useRef } from 'react';
import '../styles/member.css';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';
import { useCart } from '../components/CartContext.js';
import moment from "moment";
import { MDBAlert, MDBBadge, MDBBtn, MDBCard, MDBCardBody, MDBCardFooter, MDBCardHeader, MDBCheckbox, MDBChip, MDBCol, MDBDatepicker, MDBIcon, MDBInput, MDBListGroup, MDBListGroupItem, MDBModal, MDBModalBody, MDBModalContent, MDBModalDialog, MDBModalFooter, MDBModalHeader, MDBModalTitle, MDBPopconfirm, MDBPopconfirmMessage, MDBRadio, MDBRow, MDBSelect, MDBTimepicker, MDBTooltip, MDBTypography } from 'mdb-react-ui-kit';
import {
  getBussinessInfobyUrl, getGBussinessInfo,
  getClassBookingInfo,
  getMemberTransactions
} from '../../services/memberApiServices';
import deleteImg from '../../components/images/delete.svg';
import { Link, useNavigate } from "react-router-dom";
import trainerimg from '../../memberportal/assets/images/coaching.png';
import Booksessions from '../components/Booksessions';
import { idToSlug, slugToId } from '../../utils/slug';
import copy from 'clipboard-copy';
import { useLocation } from 'react-router';
import EventDetailPage from '../../components/class/eventDetails';
import unavailable from '../../memberportal/assets/images/noavilable.png';
import { formatDate } from '../../utils/DateFormat';
import shape from '../../memberportal/assets/images/badge-shap.png';
import ftinessloader from '../../memberportal/assets/images/loader.gif';
import AvailableSessionsMobile from './AvailableSessionsMobile';
import easybook from '../../components/images/easybook.png';

// Class Listing Component (from NewClassesView)
const ClassListing = ({ classInfo, slots, bookedSlots, handleSlotClick, handleEventClick }) => {
  const [isOpen, setIsOpen] = useState(false);
  const cardRef = useRef(null);

  const truncateContent = (content, maxLength) => {
    if (content && (content.length > maxLength)) {
      return content.substring(0, maxLength) + '...';
    } else {
      return content;
    }
  };

  const stripHtmlTags = (html) => {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.body.textContent || "";
  };

  const handleToggle = () => {
    const wasOpen = isOpen;
    setIsOpen(!isOpen);

    // If we're closing (Show Less), scroll to the element
    if (wasOpen) {
      setTimeout(() => {
        cardRef.current?.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest'
        });
      }, 10);
    }
  };

  return (
    <MDBCard className="bookslots_crad mb-4 position-relative" ref={cardRef}>
      <MDBCardBody>
        <div className="d-flex justify-content-between align-items-start mb-3" onClick={() => setIsOpen(!isOpen)}
        >
          <div className="flex-grow-1">
            <div className="d-flex justify-content-between">
              <div className="d-flex align-items-center flex-wrap">
                <h5 className="mb-0 me-3 book-title-text title">{classInfo.name}</h5>
                <MDBBadge color="muted" className="me-2 badg-text">{classInfo.category}</MDBBadge>
                <MDBBadge
                  color={
                    classInfo.level === "Beginner" ? "success" :
                      classInfo.level === "Intermediate" ? "warning" :
                        classInfo.level === "Advanced" ? "info" : "primary"
                  }
                  className="me-2 "
                >
                  {classInfo.level}
                </MDBBadge>
              </div>

            </div>
            <p
              className={`my-2 ${!isOpen ? "multiline-ellipsis" : ""}`}
              style={{ color: "#2f2222" }}
              title={stripHtmlTags(classInfo?.description ? classInfo.description : "--")}
              dangerouslySetInnerHTML={{ __html: classInfo?.description ? classInfo.description : "" }}
            />

            <div className="d-flex flex-wrap gap-3">
              <div className="d-flex align-items-center">
                <MDBIcon far icon="clock" className="me-2 text-secondary" />
                <span className='text-dark'>{classInfo.duration} min</span>
              </div>
              <div className="d-flex align-items-center">
                <MDBIcon fas icon="rupee-sign" className="me-1 text-secondary" />
                <span className='text-dark'>{classInfo.price}</span>
              </div>
            </div>
            <MDBBtn
              color="link"
              className="show_more"
              onClick={handleToggle}
            >
              Show {!isOpen ? 'More' : 'Less'}
              <MDBIcon icon={`chevron-${isOpen ? 'up' : 'down'}`} className="ms-1" color='primary' />
            </MDBBtn>
          </div>

        </div>

        {isOpen && (
          <>
            <hr />
            <div>
              <h5 className="mb-3">Available Time Slots</h5>
              <ClassSlotSelector
                slots={slots}
                bookedSlots={bookedSlots}
                handleSlotClick={handleSlotClick}
                classInfo={classInfo}
                handleEventClick={handleEventClick}
              />
            </div>
          </>
        )}
      </MDBCardBody>
    </MDBCard>
  );
};





// Enhanced List View Component (Date-wise grouping like reference image)
const EnhancedListview = ({
  events,
  handleclassevent,
  slotLimit,
  generateMembershipDiscount,
  formatTimeWithColoredAMPM,
  handleEventClick,
  searchQuery,
  filterCategory,
  filterLevel,
  categories,
  levels
}) => {

  const today = moment().startOf('day');

  // Filter events based on search and filters
  const filteredEvents = events
    .filter(event => {
      // Apply search filter
      const matchesSearch = searchQuery === '' ||
        event.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
        event.extendedProps.category?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        event.extendedProps.trainer?.toLowerCase().includes(searchQuery.toLowerCase());

      // Apply category filter
      const matchesCategory = filterCategory === 'all' ||
        event.extendedProps.category === filterCategory;

      // Apply level filter
      const matchesLevel = filterLevel === 'all' ||
        event.extendedProps.classInfo?.level === filterLevel;

      return matchesSearch && matchesCategory && matchesLevel && !event.isprivate;
    });

  // Group events by date
  const groupedByDate = filteredEvents.reduce((groups, event) => {
    const dateKey = moment(event.start).format('YYYY-MM-DD');
    if (!groups[dateKey]) {
      groups[dateKey] = [];
    }
    groups[dateKey].push(event);
    return groups;
  }, {});

  // Sort dates chronologically
  const sortedDates = Object.keys(groupedByDate).sort();

  if (sortedDates.length === 0) {
    return (
      <div className="no-sessions">
        <img src={unavailable} alt="" />
        <p className='my-3'>No available sessions found</p>
      </div>
    );
  }

  return (
    <div className="enhanced-listview-container">
      {sortedDates.map(dateKey => {
        const date = moment(dateKey);
        const tomorrow = today.clone().add(1, 'day');

        // Format date header like reference image
        let dateHeader = "";
        if (date.isSame(today, 'day')) {
          dateHeader = `Today, ${date.format('dddd, MMM DD')}`;
        } else if (date.isSame(tomorrow, 'day')) {
          dateHeader = `Tomorrow, ${date.format('dddd, MMM DD')}`;
        } else {
          dateHeader = `${date.format('dddd, MMM DD')}`;
        }

        const dateEvents = groupedByDate[dateKey]
          .sort((a, b) => {
            const timeA = moment(a.extendedProps.startTime, "hh:mm A");
            const timeB = moment(b.extendedProps.startTime, "hh:mm A");
            return timeA.diff(timeB);
          });

        return (
          <div key={dateKey} className="date-group-section mb-4">

            {/* Date Header - matches reference image */}
            <div className="date-header-section">
              <div className="d-flex align-items-center">
                {/* Month Badge */}
                <div className="date-badge me-3">
                  <div className="month-badge">
                    {date.format('MMM').toUpperCase()}
                  </div>
                  <div className="day-number">
                    {date.format('DD')}
                  </div>
                  <div className="day-name">
                    {date.format('dddd').toUpperCase()}
                  </div>
                </div>

                {/* Full Date Display */}
                <div>
                  <h5 className="date-full mb-0">
                    {date.format('dddd, MMM DD')}
                  </h5>
                  <p className="text-muted mt-1 mb-0">
                    {dateEvents.length} session{dateEvents.length !== 1 ? 's' : ''} available
                  </p>
                </div>
              </div>
            </div>




            {/* Events List for this date */}
            <div className="events-list-group">
              {dateEvents.map((event, index) => {
                const duration = Math.round(
                  (new Date(event.end) - new Date(event.start)) / (1000 * 60)
                );
                const isAvailable = slotLimit(event) > 0;
                const priceInfo = generateMembershipDiscount(event);
                const isLast = index === dateEvents.length - 1;

                return (
                  <div key={event.id} className="event-list-item">
                    <div className={`event-list-card ${!isAvailable ? 'event-list-full' : ''}`}>
                      <div className="d-flex align-items-center">
                        {/* Time Column - clickable for event details */}
                        <div className="pe-4"
                          onClick={() => handleEventClick(event)}
                          style={{ cursor: 'pointer' }}
                        >
                          <div className="event-time-display">
                            <h5 className="event-time-text mb-1">
                              {formatTimeWithColoredAMPM(event.extendedProps.startTime)}
                            </h5>
                            <span className="event-duration-badge">
                              {duration} min
                            </span>
                          </div>
                        </div>

                        {/* Event Details Column - clickable for event details */}
                        <div className="pe-3 flex-grow-1"
                          onClick={() => handleEventClick(event)}
                          style={{ cursor: 'pointer' }}
                        >
                          <div className="event-details-content">
                            <div className="d-flex align-items-center mb-0 mb-md-2 mb-lg-2 mb-xl-2">
                              <h6 className="event-title text-primary me-0 me-md-2 me-lg-2 me-xl-2 mb-0">{event.title}</h6>

                              {/* Category tags */}
                              <div className="d-flex flex-wrap d-none d-md-block d-lg-block d-xl-block">
                                <MDBBadge color="light" className="text-dark border status-badge">
                                  {event.extendedProps.category || 'Climbing'}
                                </MDBBadge>
                                <MDBBadge
                                  color={
                                    event.extendedProps.classInfo?.level === "Beginner" ? "success" :
                                      event.extendedProps.classInfo?.level === "Intermediate" ? "warning" :
                                        event.extendedProps.classInfo?.level === "Advanced" ? "info" : "light"
                                  }
                                  className="text-dark status-badge"
                                >
                                  {event.extendedProps.classInfo?.level || 'For All'}
                                </MDBBadge>
                                {!isAvailable && (
                                  <MDBBadge color="danger" className="text-dark status-badge">Full</MDBBadge>
                                )}
                              </div>
                            </div>

                            {/* Instructor */}
                            <div className="event-instructor-info  d-flex align-items-center">
                              <p className="text-muted  mb-0 me-3">
                                <div className="d-flex flex-wrap d-block d-md-none d-lg-none d-xl-none">
                                  <MDBBadge color="light" className="text-dark border status-badge">
                                    {event.extendedProps.category || 'Climbing'}
                                  </MDBBadge>
                                  <MDBBadge
                                    color={
                                      event.extendedProps.classInfo?.level === "Beginner" ? "success" :
                                        event.extendedProps.classInfo?.level === "Intermediate" ? "warning" :
                                          event.extendedProps.classInfo?.level === "Advanced" ? "info" : "light"
                                    }
                                    className="text-dark status-badge"
                                  >
                                    {event.extendedProps.classInfo?.level || 'For All'}
                                  </MDBBadge>
                                  {!isAvailable && (
                                    <MDBBadge color="danger" className="text-dark status-badge">Full</MDBBadge>
                                  )}
                                </div>
                                <label className='d-flex'>
                                  <span className='d-none d-md-block d-lg-block me-0 me-md-1 me-lg-1 me-xl-1 '>  Instructor: </span> <span className='subtrain-text'> {event.extendedProps.trainer}</span>
                                </label>

                              </p>
                              <div className="event-price-display d-none d-md-block d-lg-block d-xl-block">
                                {typeof event.extendedProps.price === 'string' &&
                                  event.extendedProps.price.includes('payable on arrival') ? (
                                  <small className="text-muted">{event.extendedProps.price}</small>
                                ) : (
                                  <div>
                                    <span className="">
                                      <MDBIcon fas icon="rupee-sign" className="me-1" />
                                      {priceInfo.discountAmount !== 0
                                        ? priceInfo.finalPrice.toLocaleString('en-IN')
                                        : Number(event.extendedProps.price).toLocaleString('en-IN')}
                                      {priceInfo.discountAmount !== 0 && (
                                        <span className="text-decoration-line-through ms-2 text-muted " style={{ fontSize: '12px' }}>
                                          <MDBIcon fas icon="rupee-sign" className="me-1" />
                                          {event.extendedProps.price}
                                        </span>
                                      )}
                                    </span>
                                  </div>
                                )}
                              </div>
                            </div>



                          </div>
                        </div>

                        {/* Action Column - NOT clickable for event details, only for booking */}
                        <div className="">
                          <div className="d-flex flex-column align-items-end">
                            <div className="mb-2">
                              {isAvailable ? (
                                <>
                                  <MDBBtn
                                    color="primary"
                                    size="sm"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleclassevent(event);
                                    }}
                                    className="w-100 d-none d-md-block d-lg-block d-xl-block"
                                  >
                                    Book
                                  </MDBBtn>

                                  <MDBBtn
                                    color="primary"
                                    size="sm"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleclassevent(event);
                                    }}
                                    className=" d-block d-md-none d-lg-none d-xl-none book-price_btn"
                                  >
                                    Book
                                    <p className='mb-0 d-flex align-items-center'>
                                      <MDBIcon fas icon="rupee-sign" className="me-1" />
                                      {event.extendedProps.price}
                                    </p>
                                  </MDBBtn>
                                </>

                              ) : (
                                <MDBBtn
                                  color="secondary"
                                  size="sm"
                                  disabled
                                  className="w-100"
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  Full
                                </MDBBtn>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Separator */}
                    {!isLast && <hr className="my-3" />}
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
};


// Class Slot Selector Component (from NewClassesView)
const ClassSlotSelector = ({ slots, bookedSlots, handleSlotClick, classInfo, handleEventClick }) => {
  const groupedSlots = slots.reduce((acc, slot) => {
    const dateKey = new Date(slot.startdate).toDateString();
    if (!acc[dateKey]) {
      acc[dateKey] = [];
    }
    acc[dateKey].push(slot);
    return acc;
  }, {});

  const sortedDates = Object.keys(groupedSlots).sort((a, b) =>
    new Date(a).getTime() - new Date(b).getTime()
  );

  const getAvailabilityStatus = (slot) => {
    let booked = Number(slot.bookedslots) || 0;
    const availableSpots = slot.totalslots - booked;
    const percentage = (availableSpots / slot.totalslots) * 100;
    if (availableSpots === 0) return 'full';
    // if (percentage > 80) return 'available';
    if (booked < 1) return 'available';
    return 'filling';
  };

  const getButtonColor = (status, isBooked) => {
    if (isBooked) return 'booked-slot';
    if (status === 'available') return 'aviail-Slots';
    if (status === 'filling') return 'filling-Slots';
    if (status === 'full') return 'full-Slots';
    return 'light';
  };

  return (
    <div className="space-y-4">
      {sortedDates.map(dateKey => {
        const date = new Date(dateKey);
        const daySlots = groupedSlots[dateKey].sort((a, b) => new Date(a.startdate) - new Date(b.startdate));

        const isToday = date.toDateString() === new Date().toDateString();
        const isTomorrow = date.toDateString() === new Date(Date.now() + 86400000).toDateString();

        let dateLabel = date.toLocaleDateString('en-US', {
          weekday: 'long',
          month: 'short',
          day: 'numeric'
        });

        if (isToday) dateLabel = `Today, ${dateLabel}`;
        if (isTomorrow) dateLabel = `Tomorrow, ${dateLabel}`;
        const date22 = moment(date);

        // Check if it's a weekend
        const isSaturday = date22.day() === 6;
        const isSunday = date22.day() === 0;
        const isWeekend = isSaturday || isSunday;
        console.log(isWeekend)
        return (
          <div className='mb-3' key={dateKey}>
            <div
              className={`d-flex align-items-center mb-2 ${isWeekend ? "weekend-DateLabel" : 'text-muted'}`}
            >
              <MDBIcon far icon="calendar-alt" className="me-2" />
              <span>{dateLabel}</span>
            </div>
            <MDBRow className="g-2">
              {daySlots.map(slot => {
                const isBooked = bookedSlots.includes(slot._id);
                const status = getAvailabilityStatus(slot);
                const buttonColor = getButtonColor(status, isBooked);
                const TrainerName = slot.trainerDeatils?.firstname + " " + slot.trainerDeatils?.lastname;
                const isFutureEvent = new Date(slot.enddate) > new Date();
                const hasAvailableSlots = (slot.totalslots - (Number(slot.bookedslots) || 0)) > 0;

                return (
                  <MDBCol key={slot._id} md="2" >
                    <MDBBtn
                      color={buttonColor}
                      className="w-100 d-flex flex-column align-items-center py-2 position-relative"
                      onClick={() => handleSlotClick(slot, classInfo, TrainerName)}
                      disabled={!isFutureEvent || !hasAvailableSlots || isBooked}
                    >
                      <div className="d-flex align-items-center mb-1" style={{ fontSize: '14px' }}>
                        <MDBIcon far icon="clock" className="me-1" />
                        <span>{slot.timeslot}</span>
                      </div>
                      <p className="text-center w-100 px-1 text-grayout text-truncate mb-0">
                        <i class="fa-solid fa-user-large me-1"></i> {TrainerName}
                      </p>
                      <MDBTooltip tag="div" title="More details">
                        <MDBIcon
                          fas
                          icon="info-circle"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleEventClick(slot, classInfo, TrainerName);
                          }}
                          style={{
                            zIndex: 999,
                            cursor: 'pointer',
                            position: 'absolute',
                            top: 5,
                            right: 5,
                            color: '#999',
                            fontSize: '16px',
                          }}
                        />
                      </MDBTooltip>

                      {!hasAvailableSlots && (
                        <MDBBadge color="danger" className="position-absolute top-0 end-0">
                          Full
                        </MDBBadge>
                      )}
                    </MDBBtn>
                  </MDBCol>
                );
              })}
            </MDBRow>
          </div>
        );
      })}
    </div>
  );
};


const EventDetailsPopup = ({ event, isOpen, onClose, onBook, groupedEvents, events, slotLimit }) => {

  console.log("eventevent", event, events);
  if (!event) return null;

  const formatTimeWithColoredAMPM = (timeString) => {
    if (!timeString) return '';
    const timePart = timeString.split(' ')[0];
    const ampmPart = timeString.split(' ')[1];
    if (!ampmPart) return timeString;
    const isAM = ampmPart.toUpperCase() === 'AM';
    return (
      <>
        {timePart}
        <span className={isAM ? ' ms-1' : ' ms-1'}>
          {ampmPart}
        </span>
      </>
    );
  };

  const stripHtmlTags = (html) => {
    if (!html) return '';
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.body.textContent || "";
  };

  const classInfo = event.extendedProps?.classInfo || {};
  const scheduleInfo = event.extendedProps?.scheduleinfo || {};
  console.log("scheduleInfo", scheduleInfo);


  // Use event price from extendedProps
  const eventPrice = event.extendedProps?.price || classInfo.price || 150;

  // Count upcoming dates and total slots for this class
  const classEvents = events.filter(e =>
    e.extendedProps?.classInfo?._id === classInfo._id &&
    new Date(e.start) > new Date()
  );
  const upcomingDates = [...new Set(classEvents.map(e =>
    moment(e.start).format('YYYY-MM-DD')
  ))];
  const totalSlots = classInfo?.slots || " ";

  console.log("totalSlotstotalSlots", totalSlots);



  return (
    <MDBModal open={isOpen} onClose={onClose} tabIndex='-1' className="event-details-modal">
      <MDBModalDialog className="modal-dialog-centered">
        <MDBModalContent>
          {/* Modal Header - Title and Badges */}
          <MDBModalHeader className="border-0 pb-3">
            <div className="w-100 d-flex">
              <h5 className="modal-title mb-0 me-3">
                {event.title || " "}
              </h5>
              <div className="d-flex align-items-center flex-wrap gap-2">
                <MDBBadge
                  color="light"
                  className="category-badge  border p-2 py-1"

                >
                  {event.extendedProps?.category || ' '}
                </MDBBadge>
                <MDBBadge
                  color="light"
                  className="level-badge border p-2 py-1"

                >
                  {classInfo.level || 'For All'}
                </MDBBadge>
              </div>
            </div>
            <MDBBtn className='btn-close' color='none' onClick={onClose}></MDBBtn>
          </MDBModalHeader>

          <hr className="my-1" style={{ borderColor: '#dee2e6', opacity: 1 }} />

          <MDBModalBody className="pt-0">
            <div className="class-details-content py-2">
              {/* About this class section */}
              <div className="about-section mb-2">
                <h6 className="section-title mb-1" style={{
                  color: '#333'
                }}>
                  About this class
                </h6>
                <p className="text-muted" style={{
                  fontSize: '14px'
                }}>
                  {stripHtmlTags(event.extendedProps?.description || ' ')}
                </p>
              </div>


              {/* Details section */}
              <div className="details-section mb-2">
                <h6 className="section-title mb-1" style={{
                  color: '#333'
                }}>
                  Details
                </h6>
                <ul className="list-unstyled details-list d-flex flex-wrap gap-3" style={{ fontSize: '16px' }}>
                  <li className="mb-2 d-flex align-items-center">
                    <MDBIcon far icon="clock" className='text-muted me-2 ' />
                    <div>
                      <span className='text-muted' style={{ fontSize: '12px' }}>Duration</span>
                      <h6 className="text-dark mb-0">{event.extendedProps?.duration || classInfo.duration || 90} min</h6>
                    </div>

                  </li>

                  <li className="mb-2 d-flex align-items-center">
                    <MDBIcon fas icon="rupee-sign" className='text-muted me-2' />
                    <div>
                      <span className='text-muted' style={{ fontSize: '12px' }}>Price</span>
                      <h6 className="text-dark mb-0">Rs. {eventPrice} payable on arrival</h6>
                    </div>

                  </li>

                  <li className="mb-2 d-flex align-items-center">
                    <MDBIcon fas icon="users" className='text-muted me-2 ' />
                    <div>
                      <span className='text-muted' style={{ fontSize: '12px' }}>Class Size</span>
                      <h6 className="text-dark mb-0">{event.extendedProps?.slotsRemaining || scheduleInfo.totalslots || classInfo.slots || 8} slots</h6>
                    </div>
                  </li>

                </ul>
              </div>

              {/* Additional info */}
              {/* <div className="additional-info info-section my-2 p-2">
                <p className="text-muted bg-light" >
                  Show rental: Rs. {eventPrice}  payable on arrival.{" "}
                  <strong>This session is included for Dex & Trix class members.</strong>
                </p>
              </div> */}


              {/* Schedule summary */}
              <div className="schedule-summary">
                <h6 className="section-title mb-1" style={{
                  color: '#333'
                }}>
                  Schedule
                </h6>
                <p className="text-muted mb-0  bg-light rounded p-2" style={{ fontSize: '14px' }}>
                  This class has <strong>{upcomingDates.length}</strong> upcoming dates with{' '}
                  <strong>{totalSlots}</strong> total time slots available.
                </p>
              </div>
            </div>
          </MDBModalBody>

          <MDBModalFooter className="border-0 pt-0 p-2 justify-content-center">
            <MDBBtn
              onClick={onClose}
              className="p-2 w-100 popclose-btn"
            >
              Close
            </MDBBtn>
            {/* {slotLimit(event) !== 0 ? (
              <MDBBtn
                color='primary'
                onClick={() => onBook(event)}
                className="px-4 py-2"
                style={{
                  fontSize: '16px',
                  fontWeight: '600'
                }}
              >
                <i className="fas fa-calendar-plus me-2"></i>
                Book Now
              </MDBBtn>
            ) : (
              <MDBBtn
                color='secondary'
                disabled
                className="px-4 py-2"
                style={{
                  fontSize: '16px',
                  fontWeight: '600'
                }}
              >
                <i className="fas fa-times me-2"></i>
                All Slots Booked
              </MDBBtn>
            )} */}



          </MDBModalFooter>
        </MDBModalContent>
      </MDBModalDialog>
    </MDBModal>
  );
};

const AvailableSessions = () => {
  const {
    getMemberId,
    getGymId,
    clearCart,
    handleReload
  } = useCart();
  const [plans, setPlans] = useState([]);
  const [scheduleInfo, setScheduleInfo] = useState([]);
  const [classes, setClasses] = useState([]);
  const [policyData, setPolicyData] = useState([]);
  const [trainerData, setTrainerData] = useState([]);
  const [filters, setFilters] = useState({
    classType: '',
    trainer: '',
    date: '',
    time: '',
    duration: ''
  });
  const [filteredEvents, setFilteredEvents] = useState([]);
  const [refresh, setRefresh] = useState(false)
  const [isLoading, setIsLoading] = useState(false);
  const [bookaClass, setbookaClass] = useState(false);
  const [selectedevent, setSelectedevent] = useState(null)
  const [bussinessinfo, setbusinessinfo] = useState(null)
  const [enablebook, setEnablebook] = useState(false)
  const [bookedSlots, setBookedSlots] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [filterCategory, setFilterCategory] = useState('all');
  const [filterLevel, setFilterLevel] = useState('all');
  const [viewMode, setViewMode] = useState('list');
  // Add this with your other state declarations
  const [eventDetailsModal, setEventDetailsModal] = useState(false);
  const [selectedClass, setSelectedClass] = useState(null);


  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const userGymURL = params.get('id') ? params.get('id') : "";
  let userEventGymURL = params.get('sid') ? params.get('sid') : "";
  const hostname = window.location.hostname;
  let subdomain = "";
  console.log(hostname, 'hostname');

  if (hostname.endsWith('easymembr.com') || hostname.endsWith('zencruz.com')) {
    const parts = hostname.split('.');
    if (parts.length === 3 && parts[0] !== 'www' && parts[0] !== "app" && parts[0] !== "beta") {
      subdomain = parts[0];
    }
  }

  useEffect(() => {
    async function fetchData() {
      setIsLoading(true)
      const response = await getClassBookingInfo(bussinessinfo?._id, "class");
      if (!response || response === "false") {
        return;
      }

      const tempData = await response.json();
      console.log(tempData, "tempData");

      const currentDate = new Date();

      const filteredSchedules = (tempData?.scheduleinfo || []).filter(schedule => {
        const startDate = new Date(schedule?.startdate);
        const visibledaysbefore = parseInt(schedule?.visibledaysbefore || 0, 10);

        const diffInMs = startDate - currentDate;
        const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

        const includeEvent = Math.abs(diffInDays) <= visibledaysbefore;

        return includeEvent;
      });

      const mergedPlans = (tempData?.plansinfo || []).map(plan => {
        const relatedSubplans = (tempData?.subplansinfo || []).filter(
          sp => sp.baseplan?.toString() === plan._id?.toString()
        );

        return {
          ...plan,
          subplans: relatedSubplans.length > 0 ? relatedSubplans : (plan.subplans || [])
        };
      });

      setPlans(mergedPlans);
      setScheduleInfo(filteredSchedules);
      setClasses(tempData?.classinfo || []);
      setPolicyData(tempData?.cancelationinfo || []);
      setTrainerData(tempData?.staffinfo || []);
      setIsLoading(false)
    }

    if (bussinessinfo?._id) {
      fetchData();
    }
  }, [refresh, bussinessinfo]);
  useEffect(() => {
    if (scheduleInfo.length > 0) {
      let scheduleessData = scheduleInfo.filter((obj) => new Date(obj.enddate) > new Date())
      let scheduleFilterData = scheduleessData.map((itm) => {
        let data = trainerData.find((obj) => obj._id == itm.trainerid);
        itm.trainerDeatils = data;
        return itm;
      });
      setScheduleInfo(scheduleFilterData);
    }
  }, [trainerData]);
  // Group schedules by class ID for ClassListing component
  const slotsByClass = scheduleInfo.reduce((acc, schedule) => {

    if (schedule.isprivate === true) {
      return acc;
    }

    if (!acc[schedule.classid]) {
      acc[schedule.classid] = [];
    }

    acc[schedule.classid].push(schedule);

    return acc;
  }, {});

  const storedUrl = sessionStorage.getItem("pendingRedirectUrl");



  const handleViewDetails = (classInfo) => {
    setSelectedClass(classInfo);
    setEventDetailsModal(true);
  };

  const handleCloseDetails = () => {
    setEventDetailsModal(false);
    setSelectedClass(null);
  };

  const handleBookFromDetails = () => {
    handleCloseDetails();

    // If we have the full event with extendedProps, use it directly
    if (selectedClass?.extendedProps) {
      handleclassevent(selectedClass);
    }
    // Otherwise, find the first slot for this class
    else if (selectedClass?._id) {
      const firstSlot = slotsByClass[selectedClass._id]?.[0];
      if (firstSlot) {
        const eventData = {
          id: firstSlot._id,
          title: selectedClass.name,
          start: new Date(firstSlot.startdate),
          end: new Date(firstSlot.enddate),
          extendedProps: {
            price: selectedClass.price,
            trainer: firstSlot.trainerDeatils?.firstname + ' ' + firstSlot.trainerDeatils?.lastname,
            slotsBooked: firstSlot.bookedslots,
            slotsRemaining: firstSlot.totalslots,
            startTime: firstSlot.timeslot,
            endTime: moment(firstSlot.timeslot, "hh:mm A").add(selectedClass.duration, 'minutes').format("hh:mm A"),
            classInfo: selectedClass,
            scheduleinfo: firstSlot
          }
        };
        handleclassevent(eventData);
      }
    }
  };


  let events = useMemo(() => {
    if (!Array.isArray(scheduleInfo) || !Array.isArray(classes) || !Array.isArray(trainerData) || !Array.isArray(policyData)) {
      return [];
    }
    console.log(scheduleInfo, 'scheduleInfo');

    return scheduleInfo
      .filter(schedule => schedule && schedule.classid && schedule.startdate && schedule.enddate)
      .sort((a, b) => {
        const dateA = new Date(a.startdate);
        const dateB = new Date(b.startdate);

        if (dateA.getTime() !== dateB.getTime()) {
          return dateA.getTime() - dateB.getTime();
        }

        const timeA = moment(a.timeslot || "00:00 AM", "hh:mm A");
        const timeB = moment(b.timeslot || "00:00 AM", "hh:mm A");

        return timeA.diff(timeB);
      })
      .map(schedule => {
        const classInfo = classes.find(cls => cls?._id === schedule.classid) || {};
        const trainer = trainerData.find(tr => tr?._id === schedule.trainerid) || {};
        const policy = policyData.find(pol => pol?._id === schedule.cancellationpolicyid) || {};
        const duration = parseInt(classInfo.duration, 10) || 0;

        const startMoment = moment(schedule?.timeslot, "hh:mm A");
        const endMoment = startMoment.clone().add(duration, 'minutes');
        const cancellationPolicy = policy?.cancelfee?.length > 0 ? policy.cancelfee.filter(fee => fee.checked) : '';
        const membership = classInfo?.membershipdiscount?.length > 0 ? classInfo?.membershipdiscount.filter(data => data.checked) : "";

        return {
          id: schedule._id,
          title: classInfo.name || "Unknown Class",
          start: new Date(schedule.startdate),
          end: new Date(schedule.enddate),
          isprivate: schedule?.isprivate ? schedule.isprivate : false,
          extendedProps: {
            price: classInfo.price || 0,
            trainer: `${trainer.firstname} ${trainer.lastname}` || "Unknown Trainer",
            slotsBooked: schedule.bookedslots || 0,
            slotsRemaining: schedule.totalslots ? schedule.totalslots : classInfo.slots || 0,
            startTime: startMoment.format("hh:mm A"),
            endTime: endMoment.format("hh:mm A"),
            cancellationPolicy: cancellationPolicy,
            eventType: !schedule.onetime ? `Recurring(${schedule?.recurrence?.recurrencetype})` : "One-Time",
            description: classInfo?.description,
            membershipdiscount: membership,
            scheduleinfo: schedule,
            classInfo: classInfo,
            trainerInfo: trainer,
            category: classInfo.category || '',
            duration: duration
          }
        };
      });

  }, [scheduleInfo, classes, trainerData, policyData]);

  // Apply filters when events or filters change
  useEffect(() => {
    if (events.length > 0) {
      applyFilters();
    }
  }, [events]);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const applyFilters = () => {
    let result = [...events];

    if (filters.classType) {
      result = result.filter(event =>
        event.title.toLowerCase().includes(filters.classType.toLowerCase()) ||
        (event.extendedProps.category && event.extendedProps.category.toLowerCase().includes(filters.classType.toLowerCase()))
      );
    }

    if (filters.trainer) {
      result = result.filter(event =>
        event.extendedProps.trainer.toLowerCase().includes(filters.trainer.toLowerCase())
      );
    }

    if (filters.date) {
      const filterDate = moment(filters.date).format('YYYY-MM-DD');
      result = result.filter(event =>
        moment(event.start).format('YYYY-MM-DD') === filterDate
      );
    }

    if (filters.time) {
      result = result.filter(event => {
        const timePeriod = event.extendedProps.startTime.includes('AM') ? 'AM' : 'PM';
        return timePeriod === filters.time;
      });
    }

    if (filters.duration) {
      const durationValue = parseInt(filters.duration);
      result = result.filter(event => {
        const eventDuration = event.extendedProps.duration;
        return eventDuration === durationValue;
      });
    }

    setFilteredEvents(result);
  };

  const handleApplyFilters = (e) => {
    e.preventDefault();
    applyFilters();
  };

  const handleClearFilters = (e) => {
    e.preventDefault();
    setFilters({
      classType: '',
      trainer: '',
      date: '',
      time: '',
      duration: ''
    });
    setFilteredEvents(events);
  };

  console.log(slotsByClass, 'slotsByClass');

  // Get unique class types for filter dropdown
  const uniqueClassTypes = [...new Set(events.map(event => event.title))];
  // Get unique trainers for filter dropdown
  const uniqueTrainers = [...new Set(events.map(event => event.extendedProps.trainer))];
  const scheduleClasses = classes.filter(classInfo =>
    slotsByClass[classInfo._id] && slotsByClass[classInfo._id].length > 0
  );
  // Filter classes for ClassListing view
  const filteredClasses = scheduleClasses.filter(classInfo => {
    const matchesSearch = searchQuery === '' ||
      classInfo.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      classInfo.category.toLowerCase().includes(searchQuery.toLowerCase());

    const matchesCategory = filterCategory === 'all' || classInfo.category === filterCategory;
    const matchesLevel = filterLevel === 'all' || classInfo.level === filterLevel;

    return matchesSearch && matchesCategory && matchesLevel;
  });

  const categories = Array.from(new Set(classes.map(c => c.category)));
  const levels = ['Beginner', 'Intermediate', 'Advanced'];

  console.log('Query Param ID:', userGymURL);
  console.log('Subdomain:', subdomain);

  useEffect(() => {
    const fetchBusiness = async () => {
      // if (!localStorage.getItem("loggedMemberInfo") && !localStorage.getItem("memberinfo")) {
      //   navigate('/memberlogin', { state: { path: userEventGymURL != "" ? `/availablesessions?sid=${userEventGymURL}` : "/availablesessions" } })
      //   return
      // }
      const identifier = subdomain || userGymURL;
      const type = subdomain ? 'subdomain' : 'prefix';
      if (subdomain) {
        const response = await getBussinessInfobyUrl(identifier, type);

        if (!response || response === "false") {
          return;
        }

        const businessInfo = await response.json();
        console.log(businessInfo);
        setbusinessinfo(businessInfo);
      } else {
        const response = await getGBussinessInfo(
          getGymId()
          // "67502055bfca0b906a81dfbe"
          // "6492d1a715b0ba904e95abe1"
        );
        if (!response || response === "false") {
          return;
        }
        const recinfo = await response.json();
        if (recinfo) {
          setbusinessinfo(recinfo)
        }
      }
    };

    fetchBusiness();
  }, [subdomain, getGymId]);


  // eventData: the freshly selected slot, passed directly by callers to avoid stale
  // closure over selectedevent state (React batches setSelectedevent — it hasn't
  // flushed yet when this function runs in the same event handler).
  const togglebookaClass = (eventData = null) => {
    if (!localStorage.getItem("loggedMemberInfo") || !localStorage.getItem("memberinfo")) {

      const currentUrl = window.location.href;

      sessionStorage.setItem("pendingRedirectUrl", currentUrl);

      // Save selected slot so the booking popup reopens automatically after login.
      // Prefer the directly-passed event; fall back to state for callers that don't pass it.
      const eventToSave = eventData || selectedevent;
      if (eventToSave) {
        sessionStorage.setItem("pendingSelectedEvent", JSON.stringify(eventToSave));
      }

      const classRequiresWaiver = eventToSave?.classInfo?.requireWaiver === true;
      console.log("classRequiresWaiver", classRequiresWaiver);

      navigate('/memberlogin', { state: { path: userEventGymURL != "" ? `/availablesessions?sid=${userEventGymURL}` : "/availablesessions", waiverstatus: classRequiresWaiver } })
      return
    } else {
      setEnablebook(true)
      setbookaClass(!bookaClass);
    }
  }


  // Handle slot click for ClassListing
  const handleSlotClick = (slot, classInfo, trainerName) => {
    console.log(slot);
    const startMoment = moment(slot?.timeslot, "hh:mm A");
    const duration = parseInt(classInfo.duration, 10) || 0;
    const endMoment = startMoment.clone().add(duration, 'minutes');
    const policy = policyData.find(pol => pol?._id === slot.cancellationpolicyid) || {};
    const cancellationPolicy = policy?.cancelfee?.length > 0 ? policy.cancelfee.filter(fee => fee.checked) : '';

    const eventData = {
      id: slot._id,
      title: classInfo.name || "Unknown Class",
      start: new Date(slot.startdate),
      end: new Date(slot.enddate),
      isprivate: slot?.isprivate ? slot.isprivate : false,
      extendedProps: {
        price: classInfo.price || 0,
        trainer: trainerName || "Unknown Trainer",
        slotsBooked: slot.bookedslots || 0,
        slotsRemaining: slot.totalslots ? slot.totalslots : classInfo.slots || 0,
        startTime: startMoment.format("hh:mm A"),
        endTime: endMoment.format("hh:mm A"),
        cancellationPolicy: cancellationPolicy,
        eventType: !slot.onetime ? `Recurring(${slot?.recurrence?.recurrencetype})` : "One-Time",
        description: classInfo?.description,
        membershipdiscount: classInfo?.membershipdiscount?.filter(data => data.checked) || "",
        scheduleinfo: slot,
        classInfo: classInfo,
        trainerInfo: slot.trainerDeatils || {},
        category: classInfo.category || '',
        duration: duration
      }
    };

    console.log("Selected event:", eventData);
    setSelectedevent(eventData.extendedProps);
    togglebookaClass(eventData.extendedProps);
  };

  const handleBookSlot = (slotId) => {
    // Your existing booking logic
  };

  const handleclassevent = (event) => {
    setSelectedevent(event.extendedProps)
    togglebookaClass(event.extendedProps)
    setscheduModal(false)
  }

  const [invoiceCheck, setInvoiceCheck] = useState(false)

  const handleCallback = () => {
    setbookaClass(false)
    setRefresh(true)
    setInvoiceCheck(false)
  }

  const slotLimit = (event) => {
    return event?.extendedProps?.slotsRemaining - event?.extendedProps?.slotsBooked
  }

  const handleRefresh = () => {
    setRefresh(true)
    handleReload()
  }

  const [schedulModal, setscheduModal] = useState(false);
  const scheduleopen = () => setscheduModal(!schedulModal);
  const [eventdata, setEventdata] = useState(null)
  const [copyLink, setcopyLink] = useState(false);
  const [basicModal, setBasicModal] = useState(false);
  const cancelOpen = () => setBasicModal(!basicModal);
  const [policyinfo, setPolicyinfo] = useState([])
  const [selectedEvent, setSelectedEvent] = useState(userEventGymURL)

  const handleevents = () => {
    setSelectedEvent("")
  }

  const findEventById = (events, id) => {
    let event = events.find(item => item.id === id);
    if (!event) {
      const normalizedId = id.replace(/^0+/, '');
      event = events.find(item => item.id === normalizedId);
    }
    return event;
  };

  console.log(userEventGymURL, 'userEventGymURL');
  const eventId = slugToId(userEventGymURL);
  console.log(eventId, 'eventId');
  const filteredEvent = findEventById(events, eventId);
  console.log(filteredEvent, 'filteredEvent');

  const handleShare = async () => {
    try {
      console.log(eventdata?.extendedProps?.scheduleinfo?._id, 'eventshare');
      const slug = idToSlug(eventdata?.extendedProps?.scheduleinfo?._id);
      const params = new URLSearchParams(window.location.search);
      const id = params.get("id");

      let shareUrl;
      let PRIMARY_SERVER_URL = `${window.location.protocol}//${window.location.hostname}/api/`;
      if (PRIMARY_SERVER_URL.includes("localhost")) {
        PRIMARY_SERVER_URL = process.env.REACT_APP_PRIMARY_SERVER_URL
      }
      const apiUrl = PRIMARY_SERVER_URL;
      const baseUrl = apiUrl.replace(/\/api\/?$/, "");

      // if (id) {
      //   shareUrl = `${window.location.origin}${window.location.pathname}?id=${id}&sid=${slug}`;
      // } else {
      // shareUrl = `${baseUrl}/booking/${slug}`;
      shareUrl = `${window.location.protocol}//${window.location.hostname}/api/booking/${slug}`;
      // }

      if (navigator.share) {
        await navigator.share({
          title: eventdata?.title || 'Event Invitation',
          text: [
            `Join me for: ${eventdata?.title}`,
            eventdata?.extendedProps?.date && `When: ${eventdata?.extendedProps?.date}`,
            eventdata?.extendedProps?.location && `Where: ${eventdata?.extendedProps?.location}`,
            eventdata?.extendedProps?.trainer && `Host: ${eventdata?.extendedProps?.trainer}`,
            eventdata?.extendedProps?.description && `Details: ${eventdata?.extendedProps?.description}`
          ].filter(Boolean).join('\n\n'),
          url: shareUrl
        });
      }
    } catch (err) {
      console.log('Share failed:', err);
    }
  };

  const handlecopyDomainuserUrl = () => {
    const slug = idToSlug(eventdata?.extendedProps?.scheduleinfo?._id);
    const params = new URLSearchParams(window.location.search);
    const id = params.get("id");

    let shareUrl;
    const apiUrl = process.env.REACT_APP_PRIMARY_SERVER_URL;
    const baseUrl = apiUrl.replace(/\/api\/?$/, "");

    // if (id) {
    //   shareUrl = `${window.location.origin}${window.location.pathname}?id=${id}&sid=${slug}`;
    // } else {
    // shareUrl = `${baseUrl}/booking/${slug}`;
    shareUrl = `${window.location.protocol}//${window.location.hostname}/api/booking/${slug}`;
    // }

    copy(shareUrl);
    console.log("Share URL:", shareUrl);
    setcopyLink(true);
  }

  const handlepolicy = (eventinfo) => {
    setPolicyinfo(eventinfo)
    setBasicModal(true)
  }

  const handleEventClick = (event) => {

    // If it's a schedule slot (from ClassSlotSelector)
    if (event.trainerDeatils) {
      // This is a schedule slot, create a proper event object
      const eventData = {
        id: event._id,
        title: event.classInfo?.name || "Unknown Class",
        start: new Date(event.startdate),
        end: new Date(event.enddate),
        extendedProps: {
          classInfo: event.classInfo,
          scheduleinfo: event,
          trainer: event.trainerDeatils?.firstname + ' ' + event.trainerDeatils?.lastname,
          price: event.classInfo?.price,
          description: event.classInfo?.description,
          duration: event.classInfo?.duration
        }
      };
      setEventdata(eventData);
      scheduleopen();
    }
    // If it's already an event object from EnhancedListview or calendar view
    else {
      setEventdata(event);
      setEventDetailsModal(true); // Open the new popup
    }
  };


  useEffect(() => {
    try {
      if (storedUrl && filteredEvent) {
        setEnablebook(true);
        setbookaClass(true);

        if (filteredEvent?.extendedProps) {

          setSelectedevent(filteredEvent.extendedProps);
        }

        sessionStorage.removeItem("pendingRedirectUrl");
        sessionStorage.removeItem("pendingSelectedEvent");
      }
    } catch (error) {
      console.error("Error accessing sessionStorage:", error);
    }
  }, [storedUrl, filteredEvent]);

  // General booking link post-login restore: no sid= in URL, so filteredEvent is always
  // undefined. Restore the slot the user had selected before being sent to login.
  useEffect(() => {
    if (!bussinessinfo || userEventGymURL) return;
    const pendingEventStr = sessionStorage.getItem("pendingSelectedEvent");
    const storedRedirectUrl = sessionStorage.getItem("pendingRedirectUrl");
    if (pendingEventStr && storedRedirectUrl) {
      try {
        const pendingEvent = JSON.parse(pendingEventStr);
        setSelectedevent(pendingEvent);
        setEnablebook(true);
        setbookaClass(true);
        sessionStorage.removeItem("pendingSelectedEvent");
        sessionStorage.removeItem("pendingRedirectUrl");
      } catch (e) {
        console.error("Error restoring pending booking:", e);
      }
    }
  }, [bussinessinfo]);





  const handleEventClickList = (slot, classInfo, trainerName) => {
    const startMoment = moment(slot?.timeslot, "hh:mm A");
    const duration = parseInt(classInfo.duration, 10) || 0;
    const endMoment = startMoment.clone().add(duration, 'minutes');
    const policy = policyData.find(pol => pol?._id === slot.cancellationpolicyid) || {};
    const cancellationPolicy = policy?.cancelfee?.length > 0 ? policy.cancelfee.filter(fee => fee.checked) : '';

    const eventData = {
      id: slot._id,
      title: classInfo.name || "Unknown Class",
      start: new Date(slot.startdate),
      end: new Date(slot.enddate),
      isprivate: slot?.isprivate ? slot.isprivate : false,
      extendedProps: {
        price: classInfo.price || 0,
        trainer: trainerName || "Unknown Trainer",
        slotsBooked: slot.bookedslots || 0,
        slotsRemaining: slot.totalslots ? slot.totalslots : classInfo.slots || 0,
        startTime: startMoment.format("hh:mm A"),
        endTime: endMoment.format("hh:mm A"),
        cancellationPolicy: cancellationPolicy,
        eventType: !slot.onetime ? `Recurring(${slot?.recurrence?.recurrencetype})` : "One-Time",
        description: classInfo?.description,
        membershipdiscount: classInfo?.membershipdiscount?.filter(data => data.checked) || "",
        scheduleinfo: slot,
        classInfo: classInfo,
        trainerInfo: slot.trainerDeatils || {},
        category: classInfo.category || '',
        duration: duration
      }
    };
    setEventdata(eventData)
    scheduleopen()
  };
  const isFutureEvent = (event) => {
    const endDate = new Date(event?.end);
    const combinedEndDateTime = moment(endDate)
      .set({
        hour: moment(event?.extendedProps?.endTime, "hh:mm A").hour(),
        minute: moment(event?.extendedProps?.endTime, "hh:mm A").minute(),
        second: 0,
      })
      .toDate();

    return new Date() < combinedEndDateTime;
  };

  const stripHtmlTags = (html) => {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.body.textContent || "";
  };

  const truncateContent = (content, maxLength) => {
    if (content && (content.length > maxLength)) {
      return content.substring(0, maxLength) + '...';
    } else {
      return content;
    }
  };

  const [groupedEvents, setGroupedEvents] = useState({});
  const displayEvents = filteredEvents.length > 0 || Object.values(filters).some(f => f !== '')
    ? filteredEvents
    : events;

  useEffect(() => {
    // Group events by date for calendar view
    const grouped = {};
    displayEvents
      .filter(event => new Date(event.start) > new Date() && !event.isprivate)
      .forEach(event => {
        const dateKey = moment(event.start).format('YYYY-MM-DD');
        if (!grouped[dateKey]) {
          grouped[dateKey] = [];
        }
        grouped[dateKey].push(event);
      });

    setGroupedEvents(grouped);
  }, [events, filteredEvents]);

  const getDateLabel = (dateStr) => {
    const today = moment().startOf('day');
    const tomorrow = moment().add(1, 'day').startOf('day');
    const date = moment(dateStr);

    // Check if it's a weekend
    const isSaturday = date.day() === 6;
    const isSunday = date.day() === 0;
    const isWeekend = isSaturday || isSunday;

    if (date.isSame(today, 'day')) {
      return {
        label: "Today",
        date: date.format('DD-MMM-YYYY'),
        day: date.format('dddd'),
        isWeekend,
        isSaturday,
        isSunday
      };
    } else if (date.isSame(tomorrow, 'day')) {
      return {
        label: "Tomorrow",
        date: date.format('DD-MMM-YYYY'),
        day: date.format('dddd'),
        isWeekend,
        isSaturday,
        isSunday
      };
    } else {
      return {
        label: "",
        date: date.format('DD-MMM-YYYY'),
        day: date.format('dddd'),
        isWeekend,
        isSaturday,
        isSunday
      };
    }
  };

  console.log(groupedEvents, 'groupedEvents');
  const [memberData, setMemberData] = useState({});
  console.log("memberData", memberData)

  useEffect(() => {
    const fetchMemberData = async () => {
      try {
        if (!localStorage.getItem("loggedMemberInfo") && !localStorage.getItem("memberinfo")) {
          return
        }
        const response = await getMemberTransactions(getMemberId());
        if (response && response !== "false") {
          const data = await response.json();
          if (data && data.length > 0) {
            setMemberData(data[0]);
          }
        }
      } catch (error) {
        console.error("Error fetching member data:", error);
      } finally {
        setRefresh(false)
      }
    };
    fetchMemberData();
  }, [getMemberId, refresh]);

  const generateMembershipDiscount = (sessionInfo) => {
    console.log(sessionInfo, 'sessionInfo');
    const classinfo = sessionInfo?.extendedProps?.classInfo;
    console.log(classinfo, 'classinfo');

    const memberMembershipInfo = memberData?.trans || [];
    console.log(memberMembershipInfo, 'memberData');

    const currentDate = new Date();

    // Filter memberships where expiry date is greater than current date
    const activeMemberships = memberMembershipInfo.length > 0 ? memberMembershipInfo.filter(membership => {
      const expiryDate = new Date(membership.expirydate);
      return expiryDate > currentDate;
    }) : [];

    console.log('Active memberships:', activeMemberships);

    // If no active memberships or no class info, return no discount
    if (!classinfo || !classinfo.membershipdiscount || activeMemberships.length === 0) {
      return {
        discountPercentage: 0,
        discountAmount: 0,
        finalPrice: parseFloat(classinfo?.price) || 0
      };
    }

    const classPrice = parseFloat(classinfo.price);
    let highestDiscount = 0;

    // Check each active membership against class discount rules
    activeMemberships.forEach(membership => {
      // Find matching discount rule in class
      const matchingDiscount = classinfo.membershipdiscount.find(
        discount =>
          discount.membershipname === membership.itemid &&
          discount.checked === true
      );

      // If found and it's higher than current highest, update
      if (matchingDiscount) {
        const discountValue = parseFloat(matchingDiscount.discount);
        if (discountValue > highestDiscount) {
          highestDiscount = discountValue;
        }
      }
    });

    // Calculate discount amount and final price
    const discountAmount = (classPrice * highestDiscount) / 100;
    const finalPrice = classPrice - discountAmount;

    return {
      discountPercentage: highestDiscount,
      discountAmount: discountAmount,
      finalPrice: finalPrice
    };
  };

  if (isLoading) {
    return <div className="dashboard-loading"> <div><img src={ftinessloader} alt="" /> </div> <h4 className='mt-2'> Loading.....</h4></div>;
  }
  const getRecurrenceText = (slot) => {
    const recurrence = slot?.extendedProps?.scheduleinfo?.recurrence || {};
    const recurrencetype = recurrence?.recurrencetype;

    const weekMap = ["1st", "2nd", "3rd", "4th", "5th"];
    const dayMap = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

    let recurrenceText = "";

    if (recurrencetype === "monthly") {
      let weeks = recurrence.value || [];
      let days = recurrence.subvalue || [];

      const allWeeks = weeks.includes(-1);
      const allDays = days.includes(-1);

      const weekText = allWeeks
        ? "every week"
        : weeks.map(i => weekMap[i - 1] || '').filter(Boolean).join(", ") + " week";

      const dayText = allDays
        ? "all days"
        : days.map(i => dayMap[i] || '').filter(Boolean).join(", ");

      if ((allWeeks || weeks.length) && (allDays || days.length)) {
        if (allWeeks) {
          recurrenceText = `Every week on ${dayText} at ${slot?.extendedProps.startTime} – ${slot?.extendedProps.endTime}`;
        } else {
          recurrenceText = `Every ${weekText} of the month on ${dayText} at ${slot?.extendedProps.startTime} – ${slot?.extendedProps.endTime}`;
        }
      }
    } else if (recurrencetype === "weekly") {
      let days = recurrence.value || [];

      const allDays = days.includes(-1);

      const dayText = allDays
        ? "all days"
        : days.map(i => dayMap[i] || '').filter(Boolean).join(", ");

      if (days.length || allDays) {
        recurrenceText = `Every week on ${dayText} at ${slot?.extendedProps.startTime} – ${slot?.extendedProps.endTime}`;
      }
    } else {
      // For onetime or unknown types
      const startMoment = moment(slot?.start, "hh:mm A");
      const endMoment = moment(slot?.end, "hh:mm A");

      recurrenceText = `${startMoment.format("hh:mm A")} – ${endMoment.format("hh:mm A")}`;
    }
    return recurrenceText;
  };

  // const formatTimeWithColoredAMPM = (timeString) => {
  //   if (!timeString) return '';

  //   // Extract time and AM/PM
  //   const timePart = timeString.split(' ')[0];
  //   const ampmPart = timeString.split(' ')[1];

  //   if (!ampmPart) return timeString;

  //   const isAM = ampmPart.toUpperCase() === 'AM';
  //   const color = isAM ? '#52CC99' : '#175ca7ff';
  //   const backgroundColor = isAM ? 'rgba(40, 167, 69, 0.1)' : 'rgba(0, 123, 255, 0.1)';

  //   return (
  //     <>
  //       {timePart}
  //       <span style={{
  //         color: color,
  //         fontWeight: 'bold',
  //         padding: '2px 2px',
  //         borderRadius: '3px',
  //         marginLeft: '2px'
  //       }}>
  //         {ampmPart}
  //       </span>
  //     </>
  //   );
  // };


  const formatTimeWithColoredAMPM = (timeString) => {
    if (!timeString) return '';

    // Extract time and AM/PM
    const timePart = timeString.split(' ')[0];
    const ampmPart = timeString.split(' ')[1];

    if (!ampmPart) return timeString;

    const isAM = ampmPart.toUpperCase() === 'AM';

    return (
      <>
        {timePart}
        <span className={isAM ? ' ms-1' : ' ms-1'}>
          {ampmPart}
        </span>
      </>
    );
  };

  let value = localStorage.getItem("loggedMemberInfo") && localStorage.getItem("memberinfo");
  return (
    <>
      {!invoiceCheck && <>
        <div className="powerfit-gym-container">
          {localStorage.getItem("loggedMemberInfo") && localStorage.getItem("memberinfo") && <Sidebar active={"2"} handleRefresh={handleRefresh} />}
          <div className="main-content p-0">
            {localStorage.getItem("loggedMemberInfo") && localStorage.getItem("memberinfo") && <Header title={"Classes & Events"} />}

            {selectedEvent ?
              <div className="overflow-hidden flex-1">
                <div className='web-sessions overflow-hidden h-100'>
                  <EventDetailPage event={filteredEvent} plans={plans} handleclassevent={handleclassevent} handleevents={handleevents} />
                </div>
                <div className='mobile-sessions h-100'>
                  <AvailableSessionsMobile event={filteredEvent} plans={plans} handleclassevent={handleclassevent} handleevents={handleevents} logourl={bussinessinfo?.logourl} />
                </div>
              </div>
              :
              <div className={`${value ? "dashboard-content" : "dashboard-content container"} `}>
                <div className='d-flex flex-column h-100'>
                  {/* View Mode Toggle */}
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <div className=" booking-container-slot">
                      {value ? <div>
                        <h5 className="mb-0">Easy Book</h5>
                      </div>
                        : <div className='book-logo'>
                          <img src={easybook} alt="" />
                        </div>}
                    </div>
                    <div className="view-mode-toggle">
                      {/* <MDBBtn
                        color={viewMode === 'list' ? 'primary' : 'light'}
                        size="sm"
                        onClick={() => setViewMode('list')}
                        className="me-2"
                      >
                        <MDBIcon fas icon="list" className="me-1" />
                        List View
                      </MDBBtn>
                      <MDBBtn
                        color={viewMode === 'calendar' ? 'primary' : 'light'}
                        size="sm"
                        onClick={() => setViewMode('calendar')}
                      >
                        <MDBIcon far icon="calendar-alt" className="me-1" />
                        Event View
                      </MDBBtn> */}
                    </div>
                  </div>

                  {viewMode === 'list' ? (
                    // List View (NewClassesView style)
                    <div className='slots-wrapper'>
                      {/* Search and Filters */}
                      <MDBRow className="mb-4">
                        <MDBCol className="mb-3 col-12 col-md-6 mb-md-0">
                          <div className="position-relative searchpanel">
                            <MDBInput
                              className='searchinput'
                              label="Search classes, instructors, or types..."
                              value={searchQuery}
                              onChange={(e) => setSearchQuery(e.target.value)}
                            />
                            <MDBIcon icon="search" className="position-absolute top-50 end-3 ps-2 translate-middle-y text-muted" />
                          </div>
                        </MDBCol>
                        <MDBCol className="mb-3 col-7 col-md-3 mb-md-0">
                          <select
                            className="form-select"
                            value={filterCategory}
                            onChange={(e) => setFilterCategory(e.target.value)}
                          >
                            <option value="all">All Types</option>
                            {categories.map(category => (
                              <option key={category} value={category}>{category}</option>
                            ))}
                          </select>
                        </MDBCol>
                        <MDBCol className='col-5 col-md-3'>
                          <select
                            className="form-select"
                            value={filterLevel}
                            onChange={(e) => setFilterLevel(e.target.value)}
                          >
                            <option value="all">All Levels</option>
                            {levels.map(level => (
                              <option key={level} value={level}>{level}</option>
                            ))}
                          </select>
                        </MDBCol>
                      </MDBRow>

                      <div className={` ${localStorage.getItem("loggedMemberInfo") && localStorage.getItem("memberinfo") ? "" : "container"}  d-flex flex-column h-100 overflow-auto`}>

                        <EnhancedListview
                          events={events}
                          handleclassevent={handleclassevent}
                          slotLimit={slotLimit}
                          generateMembershipDiscount={generateMembershipDiscount}
                          formatTimeWithColoredAMPM={formatTimeWithColoredAMPM}
                          handleEventClick={handleEventClick} // This should call the new function
                          searchQuery={searchQuery}
                          filterCategory={filterCategory}
                          filterLevel={filterLevel}
                          categories={categories}
                          levels={levels}


                        />
                      </div>
                    </div>
                  ) : (
                    // Calendar View (Original AvailableSessions view)
                    <>
                      <div className="filters-container">
                        <div className="filter-row">
                          <div className="filter-group">
                            <label className="filter-label">Class</label>
                            <select
                              className="member-filter-select form-select"
                              name="classType"
                              value={filters.classType}
                              onChange={handleFilterChange}
                            >
                              <option value="">All</option>
                              {uniqueClassTypes.map((type, index) => (
                                <option key={index} value={type}>{type}</option>
                              ))}
                            </select>
                          </div>

                          <div className="filter-group">
                            <label className="filter-label">Trainer</label>
                            <select
                              className="member-filter-select form-select"
                              name="trainer"
                              value={filters.trainer}
                              onChange={handleFilterChange}
                            >
                              <option value="">All</option>
                              {uniqueTrainers.map((trainer, index) => (
                                <option key={index} value={trainer}>{trainer}</option>
                              ))}
                            </select>
                          </div>

                          <div className="filter-group">
                            <label className="filter-label">Date</label>
                            <input
                              type="date"
                              className="filter-date form-control"
                              name="date"
                              value={filters.date}
                              onChange={handleFilterChange}
                            />
                          </div>

                          <div className="filter-group">
                            <label className="filter-label">Time</label>
                            <select
                              className="member-filter-select form-select"
                              name="time"
                              value={filters.time}
                              onChange={handleFilterChange}
                            >
                              <option value="">Any</option>
                              <option value="AM">AM</option>
                              <option value="PM">PM</option>
                            </select>
                          </div>

                          <div className="filter-group">
                            <label className="filter-label">Duration</label>
                            <select
                              className="member-filter-select form-select"
                              name="duration"
                              value={filters.duration}
                              onChange={handleFilterChange}
                            >
                              <option value="">Any</option>
                              <option value="30">30m</option>
                              <option value="45">45m</option>
                              <option value="60">60m</option>
                            </select>
                          </div>

                          <div className="filter-buttons align-self-end">
                            <button className="filter-btn apply-btn" onClick={handleApplyFilters}>
                              Apply
                            </button>
                            <button className="filter-btn cancel-btn" onClick={handleClearFilters}>
                              Clear
                            </button>
                          </div>
                        </div>
                      </div>

                      <div className="sessions-grid flex-grow-1 overflow-auto">
                        {Object.keys(groupedEvents).length > 0 ?
                          (Object.keys(groupedEvents)
                            .sort()
                            .map(dateKey => {
                              const { label, date, day, isWeekend, isSaturday, isSunday } = getDateLabel(dateKey);
                              const dateEvents = groupedEvents[dateKey];

                              return (
                                <div key={dateKey} className="date-group">
                                  <div
                                    className={`date-header ${isSunday || isSaturday ? "sunday-view saturday-view" : ""}`}
                                    style={{
                                      borderColor: `${isSaturday ? '#2196f3' : isSunday ? '#ff9800' : 'transparent'}`,
                                    }}
                                  >
                                    {label && <span className="date-label">{label}</span>}
                                    <span>
                                      <div>
                                        <span
                                          className="day-value"
                                          style={{
                                            color: isWeekend ? '#ff9800' : 'inherit',
                                            fontWeight: isWeekend ? 'bold' : 'normal'
                                          }}
                                        >
                                          {day}
                                        </span>
                                        <h5 className="date-value"
                                          style={{
                                            color: isWeekend ? '#ff9800' : 'inherit',
                                            fontWeight: isWeekend ? 'bold' : 'normal'
                                          }}
                                        >{date}</h5>
                                      </div>
                                    </span>
                                  </div>

                                  <div className="session-cards-container">
                                    {dateEvents.map(event => {
                                      const duration = Math.round(
                                        (new Date(event.end) - new Date(event.start)) / (1000 * 60)
                                      );

                                      return (
                                        <div className={slotLimit(event) === 0 ? "session-card outofsession_card" : "session-card"} key={event.id}>
                                          <div className='session_left'>
                                            <div className='session_hader'>
                                              <h3 className="session-type">{event.title}</h3>
                                            </div>
                                            <div className='session_body'>
                                              <table className='session_table'>
                                                <tbody>
                                                  <tr>
                                                    <td width={70}>Date</td>
                                                    <td width={25}>:</td>
                                                    <td colSpan={2}>{moment(event.start).format('YYYY-MM-DD')}</td>
                                                  </tr>
                                                  <tr>
                                                    <td>Timings</td>
                                                    <td>:</td>
                                                    <td colSpan={2}>{formatTimeWithColoredAMPM(event.extendedProps.startTime)}-{formatTimeWithColoredAMPM(event.extendedProps.endTime)}</td>
                                                  </tr>
                                                  <tr>
                                                    <td>Duration</td>
                                                    <td>:</td>
                                                    <td>{duration}m</td>
                                                    <td align='right'> <button className="button-link link-color" onClick={() => handleEventClick(event)}> <u>Show More <i class="fas fa-angle-right ms-1"></i></u></button></td>
                                                  </tr>
                                                </tbody>
                                              </table>
                                            </div>

                                            <div className='session_footer'>
                                              <div className="session-trainer d-flex align-items-center">
                                                <div className='trainer-dp me-2'>
                                                  <img src={trainerimg} alt="" />
                                                </div>
                                                <div>
                                                  <span>Trainer</span>
                                                  <h6 className='m-0'>{event.extendedProps.trainer}</h6>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className='session_right'>
                                            <div className="d-flex flex-fill justify-content-center align-items-center">
                                              <div className='text-center'>
                                                <label>Price</label>
                                                <h2>  <i class="fas fa-rupee-sign"></i> {typeof event.extendedProps.price === 'string' ?
                                                  (generateMembershipDiscount(event).discountAmount !== 0 ? generateMembershipDiscount(event).finalPrice : Number(event.extendedProps.price).toLocaleString('en-IN')) :
                                                  (generateMembershipDiscount(event).discountAmount !== 0 ? generateMembershipDiscount(event).finalPrice : event.extendedProps.price || 0).toLocaleString('en-IN')}<span>/-</span> </h2>
                                                {generateMembershipDiscount(event).discountAmount !== 0 && <label className='text-decoration-line-through'>{(event.extendedProps.price || 0).toLocaleString('en-IN')}/-</label>}
                                              </div>
                                            </div>

                                            <div >
                                              {slotLimit(event) !== 0 ? (
                                                <MDBBtn onClick={() => handleclassevent(event)}
                                                  type="submit"
                                                  className="nav-btn orng-btn"
                                                  color="primary"
                                                >
                                                  <span className='session_btn'>Book</span>
                                                </MDBBtn>
                                              ) : (
                                                <MDBBtn
                                                  type="submit"
                                                  className="nav-btn orng-btn"
                                                  color="primary"
                                                >
                                                  <span className='session_btn'> Full</span>
                                                </MDBBtn>
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                      );
                                    })}
                                  </div>
                                </div>
                              );
                            }))
                          : (
                            <div className="no-sessions">
                              <img src={unavailable} alt="" />
                              <p className='my-3'>No available sessions found</p>
                            </div>
                          )}
                      </div>
                    </>
                  )}
                </div>
              </div>
            }
          </div>
        </div>
      </>}

      {enablebook && <Booksessions invoiceCheck={invoiceCheck} handleCallback={handleCallback} bookaClass={bookaClass} setbookaClass={setbookaClass} togglebookaClass={togglebookaClass} bussinessinfo={bussinessinfo} selectedevent={selectedevent} setInvoiceCheck={setInvoiceCheck} />}

      {/* Modals remain the same */}
      {schedulModal && <MDBModal open={schedulModal} onClose={() => setscheduModal(false)} tabIndex='-1'>
        <MDBModalDialog size="lg">
          <MDBModalContent style={{ maxHeight: '70%' }}>
            <MDBModalHeader>
              <div className="d-flex align-items-center justify-content-between w-100">
                <MDBTypography tag='h6' className="m-0 p-0">
                  {eventdata?.title}
                </MDBTypography>
                <div className='d-flex align-items-center'>
                  <div >
                    <span className='text-primary fw-300 me-2 cursor-pointer primary-icon' title="Copy"
                      onClick={handlecopyDomainuserUrl}
                    ><i class="fa-regular fa-copy "></i></span>
                    <span className='share fw-300  cursor-pointer me-2  primary-icon' title="share"
                      onClick={() => handleShare(eventdata)}
                    >
                      <MDBIcon fas icon="share-alt" />
                    </span>
                  </div>
                  <MDBBtn className='btn-close ms-3' color='none' onClick={scheduleopen}></MDBBtn>
                </div>
              </div>
            </MDBModalHeader>
            <MDBModalBody className='p-3 pt-4'
              style={{ cursor: "pointer" }}>

              {eventdata?.extendedProps?.cancellationPolicy?.length > 0 ? <div className="Cancel-Policy">
                <p className="m-0" onClick={() =>
                  handlepolicy(eventdata)
                } >Cancellation Policy</p>
              </div> : <div className="NoCancel-Policy">
                <p className="m-0">Non Refundable</p>
              </div>}

              <table className="table table-striped table-bordered compressed-table mb-0">
                <tbody>
                  <tr>
                    <td width="150px">Date</td>
                    <td>{new Date(eventdata?.start).toLocaleDateString('en-US', {
                      weekday: 'long',
                      month: 'short',
                      day: 'numeric',
                      year: "numeric"
                    })}</td>
                  </tr>
                  <tr>
                    <td width="150px">Time</td>
                    <td>{getRecurrenceText(eventdata)}</td>
                  </tr>
                  <tr>
                    <td>  Host</td>
                    <td>{eventdata?.extendedProps?.trainer ? eventdata?.extendedProps?.trainer : "UnKnown Name"}</td>
                  </tr>

                  <tr>
                    <td>Price</td>
                    <td> Rs. {eventdata?.extendedProps?.price} /-</td>
                  </tr>
                  {/* <tr>
                    <td>Slots</td>
                    <td className="text-success">  {eventdata?.extendedProps?.slotsBooked}/{eventdata?.extendedProps?.slotsRemaining} Booked</td>
                  </tr> */}
                  {/* <tr>
                    <td> Event Type</td>
                    <td>{eventdata?.extendedProps?.eventType}</td>
                  </tr> */}

                  <tr>
                    <td>Membership Discounts</td>
                    <td>
                      <div>
                        {eventdata?.extendedProps?.membershipdiscount && eventdata?.extendedProps?.membershipdiscount.length > 0
                          ? eventdata.extendedProps.membershipdiscount.map((item) => {
                            const plan = plans.find((p) => p._id === item.membershipname);
                            let subplan;
                            if (!plan) {
                              for (const p of plans) {
                                subplan = p.subplans?.find((sp) => sp._id === item.membershipname);
                                if (subplan) {
                                  return (
                                    <ul className="m-0 ps-3" key={item.membershipname}>
                                      <li className="p-1">
                                        {p.name} - {subplan.name} ({item.discount}%)
                                      </li>
                                    </ul>
                                  );
                                }
                              }
                            }

                            return (
                              <ul className="m-0 ps-3" key={item.membershipname}>
                                <li className="p-1">
                                  {plan ? plan.name : "Unknown Plan"} - {item.discount}%
                                </li>
                              </ul>
                            );
                          })
                          : (
                            <p className="mb-0">No Membership Discounts available</p>
                          )}
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td> Description</td>
                    <td><p className='mb-0 ms-2' title={stripHtmlTags(eventdata?.extendedProps?.description ? eventdata?.extendedProps?.description : "--")} dangerouslySetInnerHTML={{ __html: eventdata?.extendedProps?.description ? eventdata?.extendedProps?.description : "--" }} /></td>
                  </tr>
                </tbody>
              </table>
            </MDBModalBody>

            <MDBModalFooter className="px-3 pb-2">
              <MDBBtn color='secondary' onClick={scheduleopen}>
                Close
              </MDBBtn>
              <MDBBtn className={(isFutureEvent(eventdata) && new Date(eventdata?.start) > new Date()) ? ((slotLimit(eventdata)) === 0 ? "btn btn-warning" : 'btn btn-primary') : 'btn btn-danger'} onClick={(isFutureEvent(eventdata) && new Date(eventdata?.start) > new Date()) ? ((slotLimit(eventdata)) === 0 ? undefined : () => handleclassevent(eventdata)) : undefined}>{(isFutureEvent(eventdata) && new Date(eventdata?.start) > new Date()) ? ((slotLimit(eventdata)) === 0 ? "Slots full" : "Book") : "Completed"}</MDBBtn>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>}

      <MDBModal tabIndex='-1' open={basicModal} onClose={() => setBasicModal(false)} >
        <MDBModalDialog>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Cancellation Policy</MDBModalTitle>
              <MDBBtn className='btn-close' color='none' onClick={cancelOpen}></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
              <p className="mb-3 text-muted" style={{ fontSize: "14px" }}>
                If you cancel your booking before the class starts, a cancellation fee will be applied based on the number of days remaining.
                The fee percentage below indicates how much will be deducted, and the rest will be refunded.
              </p>

              <table className="Cancel_table">
                <tbody>
                  {policyinfo?.extendedProps?.cancellationPolicy && policyinfo?.extendedProps?.cancellationPolicy?.length > 0 ? (
                    policyinfo.extendedProps.cancellationPolicy.map(element => (
                      <tr key={element._id} className='mb-0'>
                        <td>{element.days} Day(s) Before</td>
                        <td>{element.feevalue}% Fee</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={2}>Non Refundable</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </MDBModalBody>

            <MDBModalFooter>
              <MDBBtn color='secondary' onClick={cancelOpen}>
                Close
              </MDBBtn>

            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>

      <MDBAlert
        color='success'
        autohide
        position='top-right'
        delay={2000}
        appendToBody
        open={copyLink}
        onClose={() => setcopyLink(false)}
      >Link copied to clipboard!
      </MDBAlert>
      <EventDetailsPopup
        event={eventdata}
        isOpen={eventDetailsModal}
        onClose={() => {
          setEventDetailsModal(false);
          setEventdata(null);
        }}
        onBook={() => {
          setEventDetailsModal(false);
          if (eventdata) {
            handleclassevent(eventdata);
          }
        }}
        groupedEvents={groupedEvents}
        events={events}
        slotLimit={slotLimit}
      />
    </>
  );
};

export default AvailableSessions;